import { gsap } from 'gsap'
import DrawSVGPlugin from 'gsap-trial/DrawSVGPlugin'

export default function animatedLogo() {
  /**
   * Just use DrawSVGPlugin when development
   */
  // gsap.registerPlugin(DrawSVGPlugin)
  let svgShapes = 'rect, circle, ellipse, polyline',
    gsapTimeLine = gsap.timeline({ repeat: 1, yoyo: true })

  gsapTimeLine
    .fromTo(
      svgShapes,
      { drawSVG: '100%' },
      { duration: 1, drawSVG: '50% 50%', stagger: 0.1 }
    )
    .fromTo(
      svgShapes,
      { drawSVG: '0%' },
      { duration: 0.1, drawSVG: '10%', immediateRender: false },
      '+=0.1'
    )
    .to(svgShapes, { duration: 1, drawSVG: '90% 100%', stagger: 0.5 })
    .to(svgShapes, {
      duration: 1,
      rotation: 360,
      scale: 0.5,
      drawSVG: '100%',
      stroke: 'white',
      strokeWidth: 6,
      transformOrigin: '50% 50%',
    })
    .to(svgShapes, {
      duration: 0.5,
      stroke: 'red',
      scale: 1.5,
      opacity: 0,
      stagger: 0.2,
    })
}
